import { render, staticRenderFns } from "./UsersGroup.vue?vue&type=template&id=765ed668&scoped=true&"
import script from "./UsersGroup.vue?vue&type=script&lang=js&"
export * from "./UsersGroup.vue?vue&type=script&lang=js&"
import style0 from "./UsersGroup.vue?vue&type=style&index=0&id=765ed668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765ed668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('765ed668')) {
      api.createRecord('765ed668', component.options)
    } else {
      api.reload('765ed668', component.options)
    }
    module.hot.accept("./UsersGroup.vue?vue&type=template&id=765ed668&scoped=true&", function () {
      api.rerender('765ed668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/UsersGroup.vue"
export default component.exports